import { createAction } from 'redux-actions';
import { USER_REQUEST, USER_SUCCESS, USER_FAILURE } from './constants';

export const fetchUser = createAction(USER_REQUEST);
export const userSuccess = createAction(USER_SUCCESS);
export const userFailure = createAction(USER_FAILURE);
